__turbopack_context__.v({
  "assistantAvatar": "MessageRenderer-module__nXsAaW__assistantAvatar",
  "assistantMessage": "MessageRenderer-module__nXsAaW__assistantMessage",
  "loadingContent": "MessageRenderer-module__nXsAaW__loadingContent",
  "loadingMessage": "MessageRenderer-module__nXsAaW__loadingMessage",
  "message": "MessageRenderer-module__nXsAaW__message",
  "messageAvatar": "MessageRenderer-module__nXsAaW__messageAvatar",
  "messageContent": "MessageRenderer-module__nXsAaW__messageContent",
  "messageHeader": "MessageRenderer-module__nXsAaW__messageHeader",
  "messageHeaderLeft": "MessageRenderer-module__nXsAaW__messageHeaderLeft",
  "messageRole": "MessageRenderer-module__nXsAaW__messageRole",
  "messageRoleAssistant": "MessageRenderer-module__nXsAaW__messageRoleAssistant",
  "messageRoleUser": "MessageRenderer-module__nXsAaW__messageRoleUser",
  "messageRow": "MessageRenderer-module__nXsAaW__messageRow",
  "messageRowUser": "MessageRenderer-module__nXsAaW__messageRowUser",
  "messageText": "MessageRenderer-module__nXsAaW__messageText",
  "messageTime": "MessageRenderer-module__nXsAaW__messageTime",
  "messageTimeAssistant": "MessageRenderer-module__nXsAaW__messageTimeAssistant",
  "messageTimeUser": "MessageRenderer-module__nXsAaW__messageTimeUser",
  "userAvatar": "MessageRenderer-module__nXsAaW__userAvatar",
  "userMessage": "MessageRenderer-module__nXsAaW__userMessage",
});
